module.exports = __webpack_public_path__ + "static/img/circle.e9048d9a.png";